<template>
    <div id="loginFail" style="padding: 20px;">
        <mu-container style="width: 500px">
            <mu-paper class="custom-paper" style="align-items: center;">
                <mu-flex class="right_block" style="height: 150px"direction="column">
                    <mu-flex align-items="center" justify-content="center" style="width:100%;">
                        <p>{{ $t('accessKey.accessKeyLoginFail') }}</p>
                    </mu-flex>
                    <mu-flex align-items="center" justify-content="center" style="width:100%;">
                        <mu-button color="primary" @click="refresh" full-width round style="margin-top:24px; width:80px">
                            {{ $t('accessKey.refresh') }}
                        </mu-button>
                    </mu-flex>
                </mu-flex>
            </mu-paper>
        </mu-container>
    </div>
</template>
<script>

export default {
    data() {
        return {
            registerForm: {
            },
        };
    },

    methods: {
        refresh() {
            // 刷新
            location.href = location.href;
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/views/accessKey/LoginFail/index.vue